<template>
  <div v-if="isVisible" class="modal-backdrop">
    <div class="modal-content">
      <h3>{{ $t("athletes.invite_modal_title") }}</h3>

      <!-- Input para invitar por correo -->
      <div class="email-invite form-group" v-if="false">
        <div class="input-group">
          <input v-model="email" type="email" class="form-control" :placeholder="$t('athletes.email_placeholder')" />
          <button @click="inviteByEmail" class="btn btn-primary">{{ $t("athletes.invite_email") }}</button>
        </div>
        <p v-if="emailError" class="error-message">{{ emailError }}</p>
      </div>

      <!-- Lista de emails invitados -->
      <div v-if="false && emailsInvitation.length" class="email-list">
        <p>{{ $t('athletes.invited_emails') }}</p>
        <ul>
          <li v-for="(email, index) in emailsInvitation" :key="index">{{ email }}</li>
        </ul>
      </div>

      <!-- Buscador de atletas -->
      <div class="filters-row">
        <div class="search-bar form-group">
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
            <input v-model="searchQuery" type="text" class="form-control" :placeholder="$t('athletes.search_placeholder')" />
          </div>
        </div>

        <div class="filter-bar form-group">
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-flag"></i></span>
            <select v-model="countryFilter" class="form-select">
              <option value="">{{ allCountriesLabel }}</option>
              <option v-for="country in availableCountries" :key="country" :value="country">
                {{ countryFlag(country) }} {{ country }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Lista de atletas con scroll -->
      <div class="athlete-list">
        <label v-for="athlete in filteredAthletes" :key="athlete.id" class="athlete-item">
          <input type="checkbox" v-model="selectedAthletes" :value="athlete.id" />
          <img :src="athlete.img_path" alt="athlete.name" class="athlete-img" />
          <span class="athlete-name">
            {{ athlete.name }} {{ athlete.surname }}
            <span class="athlete-row" v-if="extractCountryCode(athlete) || hasAthleteStats(athlete)">
              <span v-if="extractCountryCode(athlete)" class="athlete-country">{{ countryFlag(extractCountryCode(athlete)) }}</span>
              <span class="athlete-stats" v-if="hasAthleteStats(athlete)">
                {{ athleteCompetitions(athlete) }} · {{ athletePodiums(athlete) }}
              </span>
            </span>
          </span>
        </label>
      </div>

      <!-- Botones de acción -->
      <div class="modal-buttons">
        <button @click="confirmSelection" class="btn btn-primary">{{ $t('competitions.btn_confirm') }}</button>
        <button @click="closeModal" class="btn btn-secondary">{{ $t('competitions.btn_cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "InviteAthleteModal",
  props: {
    isVisible: Boolean,
    athletes: Array,
    competition: Object,
  },
  data() {
    return {
      selectedAthletes: [],
      email: "",
      searchQuery: "",
      emailsInvitation: [],
      emailError: "",
      countryFilter: "",
    };
  },
  computed: {
    ...mapState("competition_users",["competitionUsers"]),
    availableCountries() {
      const codes = new Set();
      (this.athletes || []).forEach(athlete => {
        const code = this.extractCountryCode(athlete);
        if (code) codes.add(code);
      });
      return Array.from(codes).sort();
    },
    allCountriesLabel() {
      return "All countries";
    },
    filteredAthletes() {

      if (!this.athletes || !this.competition || !this.competitionUsers) {
        return [];
      }

      // Extraer los IDs de los atletas ya en la competencia
      const athletesInCompetition = new Set(
          this.competitionUsers
              .filter(user => user.role_id === 1)
              .map(user => user.user.id)
      );


      return this.athletes.filter(athlete => {
        const fullName = `${athlete.name} ${athlete.surname}`.toLowerCase();
        const email = (athlete.email || '').toLowerCase();
        const query = this.searchQuery.toLowerCase();
        const matchesSearch = !query || fullName.includes(query) || email.includes(query);
        const countryCode = this.extractCountryCode(athlete);
        const matchesCountry = !this.countryFilter || countryCode === this.countryFilter;
        const notInCompetition = !athletesInCompetition.has(athlete.id);
        return matchesSearch && matchesCountry && notInCompetition;
      });
    }
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.selectedAthletes = [];
      this.emailsInvitation = [];
      this.$emit("closeModal");
    },
    confirmSelection() {
      this.$emit("inviteAthletes", this.selectedAthletes,this.emailsInvitation);
      this.closeModal();
    },
    inviteByEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.email.match(emailPattern)) {
        this.emailError = "Invalid email format";
        return;
      }
      this.emailError = "";
      this.emailsInvitation.push(this.email);
      this.email = "";
    },
    extractCountryCode(athlete) {
      const code = athlete?.country || athlete?.stats?.country_code;
      return code ? String(code).toUpperCase() : "";
    },
    countryFlag(code) {
      if (!code || code.length !== 2) return "🏳️";
      const base = 127397;
      const chars = code.toUpperCase().split("").map(c => base + c.charCodeAt(0));
      return String.fromCodePoint(...chars);
    },
    athleteCompetitions(athlete) {
      const count = Number(athlete?.stats?.competitions_count || 0);
      return `Comp: ${count}`;
    },
    athletePodiums(athlete) {
      const podium = athlete?.stats?.top_positions || {};
      const first = Number(podium.first || 0);
      const second = Number(podium.second || 0);
      const third = Number(podium.third || 0);
      return `Top ${first}/${second}/${third}`;
    },
    hasAthleteStats(athlete) {
      const hasComp = Number.isFinite(Number(athlete?.stats?.competitions_count));
      const podium = athlete?.stats?.top_positions;
      const hasPodium = podium && (Number.isFinite(Number(podium.first)) || Number.isFinite(Number(podium.second)) || Number.isFinite(Number(podium.third)));
      return hasComp || hasPodium;
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  width: 50%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}
.email-invite, .search-bar {
  margin-bottom: 15px;
}
.filters-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 12px;
}
.filters-row .search-bar {
  flex: 1;
  margin-bottom: 0;
}
.filters-row .filter-bar {
  width: 200px;
  margin-bottom: 0;
}
.email-list {
  text-align: left;
  padding: 10px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
}
.email-list ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.email-list li {
  padding: 5px 0;
  font-size: 14px;
}
.athlete-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: 50vh;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.athlete-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  padding-bottom: 15px;
}
.athlete-name {
  display: inline-flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  text-align: left;
}
.athlete-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.athlete-country {
  font-size: 12px;
  color: #555;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* Emoji-capable stack so flags render across platforms (incl. Windows) */
  font-family: "Twemoji Mozilla", "Noto Color Emoji", "Segoe UI Emoji", "Apple Color Emoji", "Segoe UI", system-ui, sans-serif;
}
.athlete-stats {
  font-size: 12px;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.athlete-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.btn {
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
.btn-primary {
  background: #28a745;
  color: white;
}
.btn-secondary {
  background: #ccc;
}
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
  }

  .filters-row {
    flex-direction: column;
    align-items: stretch;
  }

  .filters-row .search-bar,
  .filters-row .filter-bar {
    width: 100%;
  }
}
</style>